<template>
  <div class="has-bg-white is-border">

    <div
      class="is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall is-min-height-50 is-flex">
      <div class="is-self-centered">
        <span class="is-uppercase title is-6">Notaire(s)</span>
      </div>
    </div>

    <div class="columns is-12 is-gapless is-padding-left is-padding-right-small is-vcentered is-min-height-50"
         :class="!notaire.has_procuration ? 'is-border-top has-bg-white-darken-1 ' : 'has-bg-dark'"
    >
      <div class="column is-narrow">
        <div class="is-padding-top-xsmall is-padding-bottom-xsmall">
          <div>
            <input id="has_procuration" v-model="notaire.has_procuration" name="has_procuration" :disabled='!(isAdmin || isSectorManager)'
                   class="switch is-success is-rounded" type="checkbox" @input="updateNotaire()">
            <label for="has_procuration"
                   :class="!notaire.has_procuration ? '' : 'has-text-white'"
                   class="is-uppercase is-size-6"
            >
              Procuration
            </label>
          </div>
        </div>
      </div>
    </div>
    <div v-if="notaire.has_procuration"
         class="columns is-gapless has-bg-light is-padding-left-small is-padding-right-small is-padding-top-large is-padding-bottom-large">
      <div class="column is-4 is-padding-right-xsmall is-padding-left-xsmall"
           :class="{'has-content-disabled': !(isAdmin || isSectorManager)}">
        <r-label label="DATE D’ENVOI POSTAL DU COURRIER" :is-required="false"
                 :value="adv.notaire.procuration_signee_le"></r-label>
        <div class="field has-addons">
          <div class="control">
            <a class="button is-static is-border is-square">
              <span class="icon"><i class="fas fa-calendar-alt"></i></span>
            </a>
          </div>
          <div class="control is-expanded has-icons-right">
            <flat-pickr @input="updateNotaire()" :config="configDate" :disabled="!(isAdmin || isSectorManager)" type="date"
                        class="input is-padding-left-xxsmall is-padding-right-xxsmall"
                        v-model="adv.notaire.procuration_signee_le"></flat-pickr>
          </div>
          <div class="control">
            <a class="button is-grey is-inverted is-border is-square" :disabled="!(isAdmin || isSectorManager)" @click="deleteDateDenvoi()">
              <i class="fas fa-times"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="column is-4 is-padding-right-xsmall is-padding-left-xsmall">
        <r-label :label="'Numéro A/R'" :is-required="false" :value="adv.notaire.procuration_numero_ar"></r-label>
        <div class="field has-addons" :class="{'has-content-disabled': !(isAdmin || isSectorManager)}">
          <div class="control">
            <a class="button is-static is-border is-square">
              <span class="icon"><i class="far fa-mail-bulk"></i></span>
            </a>
          </div>
          <div class="control is-expanded has-icons-right">
            <v-input id="ref" name="ref" @input="procurationReceptionInput"
                     :model="adv.notaire.procuration_numero_ar"
                     v-validate="'min:1'" :errors-bag="errors" data-vv-value-path="val"
                     data-vv-as="numero a/r" data-type-cy="input" data-value-cy="input_ref">
            </v-input>
          </div>
          <div class="control">
            <a class="button is-grey is-inverted is-border is-square" :disabled="!(isAdmin || isSectorManager)" @click="deleteNumAr()">
              <i class="fas fa-times"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="column is-4 s-padding-right-xsmall is-padding-left-xsmall"
           :class="{'has-content-disabled': !(isAdmin || isSectorManager)}">
        <r-label :label="'DATE DE RÉCEPTION a/r'" :is-required="false"
                 :value="adv.notaire.procuration_accuse_ar"></r-label>
        <div class="field has-addons">
          <div class="control">
            <a class="button is-static is-border is-square">
              <span class="icon"><i class="fas fa-calendar-alt"></i></span>
            </a>
          </div>
          <div class="control is-expanded has-icons-right">
            <flat-pickr :config="configDate" @input="updateNotaire()" :disabled="!(isAdmin || isSectorManager)" type="date"
                        class="input is-padding-left-xxsmall is-padding-right-xxsmall"
                        v-model="adv.notaire.procuration_accuse_ar"></flat-pickr>
          </div>
          <div class="control">
            <a class="button is-grey is-inverted is-border is-square" :disabled="!(isAdmin || isSectorManager)"
               @click="deleteDateReception()">
              <i class="fas fa-times"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
    <template v-for="(notaire, idx) in notaires">
      <notaire-item :key="idx" :idx="idx" :source-notaire="notaire" @removeNotaire="removeNotaire"
                    @editNotaire="editNotaire"></notaire-item>
    </template>
    <div class="row-width-actions-bar">
      <button class="page-header-btn button is-grey-dark is-fullwidth is-radiusless"
              @click="addNotaire(null)">
        <span>Ajouter un notaire en concours</span>
      </button>
    </div>

    <div class="columns is-12 is-gapless is-padding-left is-padding-right-small is-vcentered is-min-height-50"
         :class="!fraisNotaire ? 'is-border-top has-bg-white-darken-1 ' : 'has-bg-dark'"
    >
      <div class="column is-narrow">
        <div class="is-padding-top-xsmall is-padding-bottom-xsmall">
          <div>
            <input id="free_notaire"
                   v-model="fraisNotaire"
                   @input="changeFreeNotaire"
                   name="free_notaire"
                   class="switch is-success is-rounded"
                   type="checkbox"
                   :disabled='!(isAdmin || isSectorManager)'>
            <label for="free_notaire"
                   :class="!fraisNotaire ? '' : 'has-text-white'"
                   class="is-uppercase is-size-6"
            >
              Frais de notaire offerts
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-gapless is-padding"
         :class="{'has-content-disabled': !(isAdmin || isSectorManager)}"
    >
      <div class="column is-4 is-padding-right">
        <r-label :label="'DATE SIGNATURE PRÉVUE'" :value="adv.vente_actee.expected_sign" :is-required="false"></r-label>
        <div class="field has-addons">
          <div class="control">
            <a class="button is-static is-border is-min-width-0 is-square">
              <span class="icon"><i class="fas fa-calendar-alt"></i></span>
            </a>
          </div>
          <div class="control is-expanded has-icons-right">
            <flat-pickr :config="configDate" :disabled='!(isAdmin || isSectorManager)' @input="updateNotaire()" type="date"
                        class="input is-padding-left-xxsmall is-padding-right-xxsmall"
                        v-model="adv.vente_actee.expected_sign"></flat-pickr>
          </div>
          <div class="control">
            <a :disabled='!(isAdmin || isSectorManager)' class="button is-grey is-inverted is-border is-min-width-0 is-square"
               @click="deleteDatePrevu()">
              <i class="fas fa-times"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="column is-4 is-padding-right">
        <r-label :label="'DATE DE SIGNATURE'" :value="sale_date" :is-required="false"></r-label>
        <div class="field has-addons">
          <div class="control">
            <a class="button is-static is-border is-min-width-0 is-square">
              <span class="icon"><i class="fas fa-calendar-alt"></i></span>
            </a>
          </div>
          <div class="control is-expanded has-icons-right">
            <flat-pickr :disabled='!(isAdmin || isSectorManager)' :config="configDate" @input="updateNotaire()" type="date"
                        class="input is-padding-left-xxsmall is-padding-right-xxsmall"
                        v-model="sale_date"></flat-pickr>
          </div>
          <div class="control">
            <a :disabled='!(isAdmin || isSectorManager)' class="button is-grey is-inverted is-border is-min-width-0 is-square"
               @click="deleteDate()">
              <i class="fas fa-times"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="!fraisNotaire">
        <r-label :label="'frais de notaire'" :value="sale_frais_notaire" :is-required="false"></r-label>
        <div class="field has-addons">
          <div class="control">
            <a class="button is-static is-border is-min-width-0 is-square">
              <span class="icon"><i :class="`fas fa-${$faCurrency}-sign`"></i></span>
            </a>
          </div>
          <div class="control is-expanded">
            <v-input id="sale_frais_notaire" name="sale_frais_notaire" @input="val => updateFrais(val)"
                      :model="sale_frais_notaire" class=""
                      v-validate="'decimal:2'" :errors-bag="errors" data-vv-value-path="val" :number='true'
                      input-type="number"
                      data-vv-as="frais de notaire">
            </v-input>
          </div>
        </div>
      </div>
    </div>
    <div id="document-list-item"
         class="is-margin-bottom is-margin-right is-margin-left is-border-bottom is-border-left is-border-right">
      <div class="is-border-top">
        <document-list-item v-for="(doc, idx) in notaireDocumentOnglet"
                            :source="doc"
                            :key="idx + '-document'"
                            :index="idx"
                            :canDrag="false"
                            :open-input="true"
                            :selected-row="selectedRow"
                            @selectedRow="val => selectedRow = val"
                            @update="updateDoc"
                            @remove="removeContratDocument">
        </document-list-item>
      </div>
      <div class="row-width-actions-bar">
        <button class="page-header-btn is-grey-dark is-fullwidth is-radiusless" :disabled="!(isAdmin || isSectorManager)"
                @click="addDocument">
          <span :class="{'has-text-grey' : !(isAdmin || isSectorManager)}">Ajouter un document à la liste</span>
        </button>
      </div>
    </div>
    <div class="has-bg-white is-border is-margin-top-xxsmall">
      <div class="row-width-actions-bar columns is-gapless">
        <div class="column is-self-centered is-padding-left is-padding-top-xsmall is-padding-bottom-xsmall">
          <span class="is-uppercase title is-6">Commentaire</span>
        </div>
        <div class="column is-narrow is-border-left">
          <button class="page-header-btn is-small is-square" @click="openComment = !openComment"><span
            class="icon is-size-4">
            <i v-if="!openComment" class="fal fa-chevron-down"></i>
            <i v-else class="fal fa-chevron-up"></i>
            </span></button>
        </div>
      </div>
      <template v-if="openComment">
        <div v-if="!openWysi" class="vadDiscussion is-border-top">
          <div
            class="vadDiscussion--bulle is-size-6 is-min-height-50 vadDiscussion--bulle--has-actions is-cut is-padding-left">
            <div class="content" v-if="(isAdmin || isSectorManager) && adv.notaire.comment" v-html="adv.notaire.comment"></div>
            <div class="content" v-else-if="!(isAdmin || isSectorManager) && adv.notaire.seller_comment" v-html="adv.notaire.seller_comment"></div>
            <div class="content" v-else>Aucun commentaire</div>
            <div class="actionsOnRow actionsOnRow--vertical">
              <div class="">
                <button @click="openWysiwyg" class="is-min-height-full">
                  <span class="icon is-small"><i class="fal fa-edit"></i></span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="is-border-top columns is-gapless">
          <div class="column" v-if="isAdmin || isSectorManager">
            <wysiwyg-editor
              :light='true' :tooltip-top="true"
              :model="commentaire"
              @change="val => commentaire = val"
              class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
            </wysiwyg-editor>
          </div>
          <div class="column" v-else>
            <wysiwyg-editor
              :light='true' :tooltip-top="true"
              :model="seller_commentaire"
              @change="val => seller_commentaire = val"
              class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
            </wysiwyg-editor>
          </div>
          <div class="actionsOnRow actionsOnRow--vertical">
            <div>
              <button @click="saveAdv()" type="button" class="button is-success">
                <span class="icon is-small"><i class="fal fa-save"></i></span>
              </button>
            </div>
            <div class="">
              <button type="button" class="actionsOnRow-btn--hoverIsDanger" @click="openWysi = false">
                <span class="icon is-small"><i class="fal fa-times"></i></span>
              </button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import { AdvMx } from '@/mixins'
  import { debounce } from 'lodash'
  import NotaireItem from './NotaireItem'
  import DocumentListItem from '../DocumentListItem'
  import { mapGetters } from 'vuex'

  export default {
    name: 'Notaire',
    mixins: [AdvMx],
    components: { NotaireItem, DocumentListItem },
    data () {
      return {
        sale_date: null,
        notaires: [],
        seller_commentaire: null,
        commentaire: null,
        openComment: true,
        openWysi: false,
        sale_frais_notaire: null,
        fraisNotaire: false,
        configDate: {
          altFormat: 'j/m/Y',
          altInput: true,
          dateFormat: 'Z'
        }
      }
    },
    computed: {
      ...mapGetters(['isAdmin', 'isSectorManager']),
      currentComment () {
        return this.adv.notaire.comment
      }
    },
    methods: {
      openWysiwyg () {
        this.openWysi = true
        this.$nextTick(() => {
          let wysiElem
          if (!this.adv.notaire.comment && !this.adv.notaire.seller_comment) {
            wysiElem = document.getElementsByClassName('ql-editor ql-blank')
            wysiElem = wysiElem[0]
            wysiElem.setAttribute('contenteditable', 'true')
            wysiElem.focus()
          } else {
            let selection = document.getSelection()
            let range = document.createRange()
            let contenteditable = document.querySelector('div[contenteditable="true"]')

            if (contenteditable.lastChild.nodeType === 3) {
              range.setStart(contenteditable.lastChild, contenteditable.lastChild.length)
            } else {
              range.setStart(contenteditable, contenteditable.childNodes.length)
            }
            selection.removeAllRanges()
            selection.addRange(range)
          }
        })
      },
      updateFrais (val) {
        this.sale_frais_notaire = val
        if (this.sale_frais_notaire === '') this.sale_frais_notaire = null
        this.updateNotaire()
      },
      saveAdv () {
        let adv = Object.assign({}, this.adv)
        this.$set(adv.notaire, 'comment', this.commentaire)
        this.$set(adv.notaire, 'seller_comment', this.seller_commentaire)
        this.$emit('saveAdv', adv)
        this.openWysi = false
      },
      deleteDateDenvoi () {
        if (this.isAdmin || this.isSectorManager) {
          this.adv.notaire.procuration_signee_le = null
        }
      },
      deleteDateReception () {
        if (this.isAdmin || this.isSectorManager) {
          this.adv.notaire.procuration_accuse_ar = null
        }
      },
      deleteDatePrevu () {
        if (this.isAdmin || this.isSectorManager) {
          this.adv.vente_actee.expected_sign = null
        }
      },
      deleteDate () {
        if (this.isAdmin || this.isSectorManager) {
          this.sale_date = null
        }
      },
      removeContratDocument (idx) {
        this.notaireDocumentOnglet.splice(idx, 1)
        this.updateNotaire()
      },
      addDocument (item = {}) {
        if (this.isAdmin || this.isSectorManager) {
          this.notaireDocumentOnglet.push({
            name: item.name || `Nouveau Document ${this.notaireDocumentOnglet.length + 1}`,
            value: item.name || `new_document_${this.notaireDocumentOnglet.length + 1}`,
            document: item.document || null
          })
          this.updateNotaire()
        }
      },
      updateDoc () {
        this.$notify({
          type: 'is-success',
          text: 'Le document à été téléchargé avec succès'
        })
        this.updateNotaire()
      },
      updateNotaire (editedAdv, save = false) {
        let cleanedDocuments = []
        for (let entry of this.notaireDocumentOnglet) {
          if (entry.document && !entry.document.path) {
            entry.document = null
          }
          cleanedDocuments.push(entry)
        }
        let adv = Object.assign({}, this.adv)
        this.$set(adv, 'sale_date', this.sale_date)
        this.$set(adv.notaire, 'documents', cleanedDocuments)
        this.$set(adv.vente_actee, 'frais_notaire', this.sale_frais_notaire)
        if (adv.sale_date === '') adv.sale_date = null
        this.$emit('commit', adv, save)
      },
      changeFreeNotaire () {
        this.fraisNotaire = !this.fraisNotaire
        this.$nextTick(() => {
          this.notaire.free_frais_notaire = this.fraisNotaire
          this.saveNotaires()
        })
      },
      accuseDeReceptionInput (val) {
        this.adv.notaire.accuse_de_reception = val
        this.saveNotaires()
      },
      procurationReceptionInput (val) {
        this.adv.notaire.procuration_numero_ar = val
        this.updateNotaire()
      },
      deleteNumAr () {
        this.adv.notaire.procuration_numero_ar = null
        this.updateNotaire()
      },
      initNotaires () {
        if (this.adv.notaire.notaires && this.adv.notaire.notaires.length > 0) {
          return this.adv.notaire.notaires.slice()
        } else {
          return []
        }
      },
      editComment (val, source, note) {
        this.$set(source, [note], val)
        this.saveNotaires()
      },
      editNotaire ({ idx, notaire }) {
        this.notaires.splice(idx, 1, notaire)
        this.saveNotaires({}, true)
      },
      addNotaire (label = null, save = true) {
        // let count = (this.notaires.length + 1) - 2
        if (!label) {
          label = 'Notaire en concours'
        }
        this.notaires.push({
          email: null,
          address: {
            city: null,
            country: null,
            line1: null,
            line2: null,
            region: null,
            state: null,
            zip_code: null
          },
          label: label,
          name: null,
          phone: null
        })
        if (save) {
          this.saveNotaires()
        }
      },
      removeNotaire (index) {
        this.notaires.splice(index, 1)
        this.saveNotaires()
      },
      saveNotaires: debounce(function (editedAdv, save = false) {
        let adv = Object.assign({}, this.adv)
        this.$set(adv.notaire, 'notaires', this.notaires)
        this.$emit('commit', adv, save)
      }, 500)
    },
    created () {
      if (this.adv.vente_actee.frais_notaire) this.sale_frais_notaire = this.adv.vente_actee.frais_notaire
      if (this.adv.notaire.notaires) {
        this.notaires = this.adv.notaire.notaires.slice()
      }
      if (this.notaires.length === 0) {
        this.addNotaire('Notaire de l\'opération', false)
      }
      if (this.adv.sale_date) this.sale_date = this.adv.sale_date
      if (this.adv.notaire.comment) this.commentaire = this.adv.notaire.comment
      if (this.adv.notaire.seller_comment) this.seller_commentaire = this.adv.notaire.seller_comment
      if ('free_frais_notaire' in this.notaire) {
        this.fraisNotaire = this.notaire.free_frais_notaire
      }
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/adv/FeuilleDeRoute/Notaire.vue